import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problems from "@/components/Problems";
import Funnel from "@/components/Funnel";
import Solutions from "@/components/Solutions";
import PulseHub from "@/components/PulseHub";
import Academy from "@/components/Academy";
import Results from "@/components/Results";
import DiagnosticForm from "@/components/DiagnosticForm";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const desktopFine = window.matchMedia("(pointer: fine)").matches && window.innerWidth >= 1024;
    if (reduced || !desktopFine) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <div className="App bg-ink">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Problems />
        <Funnel />
        <Solutions />
        <PulseHub />
        <Academy />
        <Results />
        <DiagnosticForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
